export const OsUptimeIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <circle cx='12' cy='12' r='9'></circle>
    <line x1='12' y1='7' x2='12' y2='12'></line>
    <line x1='12' y1='12' x2='16' y2='14'></line>
  </svg>
);

export const AppUptimeIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <polyline points='3 12 7 12 10 6 14 18 17 12 21 12'></polyline>
  </svg>
);

export const LastSeenIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z'></path>
    <circle cx='12' cy='12' r='3'></circle>
  </svg>
);

export const LastUpdaterIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <polyline points='23 4 23 10 17 10'></polyline>
    <polyline points='1 20 1 14 7 14'></polyline>
    <path d='M3.51 9a9 9 0 0 1 14.88-3.36L23 10'></path>
    <path d='M20.49 15a9 9 0 0 1-14.88 3.36L1 14'></path>
  </svg>
);

export const HealthcheckIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <circle cx='12' cy='12' r='9'></circle>
    <polyline points='8 12 11 15 16 9'></polyline>
  </svg>
);

export const TemperatureIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M12 3a2 2 0 0 0-2 2v9.5a4 4 0 1 0 4 0V5a2 2 0 0 0-2-2z'></path>
    <line x1='12' y1='7' x2='12' y2='17'></line>
  </svg>
);

export const BranchIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <circle cx='6' cy='6' r='2'></circle>
    <circle cx='6' cy='18' r='2'></circle>
    <circle cx='18' cy='12' r='2'></circle>
    <path d='M8 6h5a5 5 0 0 1 5 5'></path>
    <path d='M8 18h5a5 5 0 0 0 5-5'></path>
  </svg>
);

export const MemoryIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <rect x='7' y='7' width='10' height='10' rx='2'></rect>
    <path d='M9 1v4'></path>
    <path d='M15 1v4'></path>
    <path d='M9 19v4'></path>
    <path d='M15 19v4'></path>
    <path d='M1 9h4'></path>
    <path d='M1 15h4'></path>
    <path d='M19 9h4'></path>
    <path d='M19 15h4'></path>
  </svg>
);

export const CpuLoadIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <circle cx='12' cy='12' r='8'></circle>
    <path d='M12 12l4-2'></path>
    <path d='M12 4v2'></path>
    <path d='M4 12h2'></path>
    <path d='M18 12h2'></path>
  </svg>
);

export const TrendUpIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6 14l4-4 3 3 5-6'></path>
    <path d='M18 7v6h-6'></path>
  </svg>
);

export const TrendDownIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6 10l4 4 3-3 5 6'></path>
    <path d='M18 17v-6h-6'></path>
  </svg>
);

export const TrendFlatIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M6 12h12'></path>
    <path d='M14 8l4 4-4 4'></path>
  </svg>
);

export const SpikeUpIcon = ({ className }) => (
  <svg className={className} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
    <line x1='12' y1='19' x2='12' y2='5'></line>
    <polyline points='6 11 12 5 18 11'></polyline>
  </svg>
);
